import config from './globals/config';
import setScrollX from './set-scroll-x';

export default function (widthDiff, trailersSlices) {
  function animate () {
    window.requestAnimationFrame(animate);

    navigation();

    function navigation () {
      if (config.isIntroDone) {
        config.posX += (config.mousePosMod - config.posX) / config.mouseMoveSoftness;

        let translatePos = config.posX * widthDiff;
        setScrollX(translatePos, trailersSlices);
      }
    }
  }

  animate();
}
